import "./ModelSelector.css";
import ZoomModal from "../../components/ZoomModal/ZoomModal";
import { useModelSelector } from "../../customHook/ModelSelector/useModelSelector";
import ModelSelectorDesktopView from "../../components/ModelSelectorDesktopView/ModelSelectorDesktopView";
import ModelSelectorMobileView from "../../components/ModelSelectorMobileView/ModelSelectorMobileView";
import { useIsMobile } from "../../customHook/common/useIsMobile";

export default function ModelSelector({
  selectedProduct,
  setSelectedModel,
  setStep,
  step,
  selectedModel,
  selectionMode,
  setSelectionMode,
  modelsData,
  personsData,
  onRefreshModels,
  isLoading,
  pagination,
  onSearchCommit,
  onPageChange,
}) {
  const {
    searchTerm,
    onSearchChange,
    filteredModels,
    filteredPersons,
    modal,
    openModal,
    closeModal,
  } = useModelSelector(
    selectedProduct,
    selectionMode,
    modelsData,
    personsData,
    onSearchCommit
  );
  const isMobile = useIsMobile();

  const filteredData =
    selectionMode === "user"
      ? filteredPersons
      : filteredModels;

  return (
    <>
      <div className="model-selector flex-1 flex flex-col min-h-0 overflow-hidden">
        {isMobile ? (
          <ModelSelectorMobileView
            openModal={openModal}
            filteredData={filteredData}
            searchTerm={searchTerm}
            onSearchChange={onSearchChange}
            setStep={setStep}
            step={step}
            setSelectedModel={setSelectedModel}
            selectedModel={selectedModel}
            selectedProduct={selectedProduct}
            selectionMode={selectionMode}
            onSelectionModeChange={setSelectionMode}
            onRefreshModels={onRefreshModels}
            isLoading={isLoading}
            pagination={pagination}
            onPageChange={onPageChange}
          />
        ) : (
          <ModelSelectorDesktopView
            filteredData={filteredData}
            searchTerm={searchTerm}
            onSearchChange={onSearchChange}
            openModal={openModal}
            setStep={setStep}
            step={step}
            setSelectedModel={setSelectedModel}
            selectedModel={selectedModel}
            selectedProduct={selectedProduct}
            selectionMode={selectionMode}
            onSelectionModeChange={setSelectionMode}
            onRefreshModels={onRefreshModels}
            isLoading={isLoading}
            pagination={pagination}
            onPageChange={onPageChange}
          />
        )}
      </div>

      <ZoomModal
        modalId="modelZoomModal"
        front={modal.front}
        back={modal.back}
        onClose={closeModal}
      />
    </>
  );
}
